import styled from 'styled-components';

import media from '@/styles/media.style';
import { BLACK } from '@/styles/variables.style';

export const Wrapper = styled.div`
  padding-top: 20px;
  background: ${BLACK};
`;

export const Text = styled.p`
  margin: 0;
  // padding: 20px 0;
  color: #ccc;
  font-size: 9px;
  line-height: 11px;
  letter-spacing: 0.3px;

  ${media.tabletP`
    padding: 20px 80px 60px 80px;
    font-size: 11px;
    line-height: 13px;
    letter-spacing: 0.4px;
  `};
`;



// WEBPACK FOOTER //
// ./src/components/GlobalMenu/CopyRight.style.js